import { Component, Fragment } from 'react';
import { Link } from '../../configs/routes';
import Field from '../ui/field';
import Button from '../ui/button';
import BlockHeader from '../plan/blockHeader';
import { createLeadGeneric, createActivity } from '../../utils/leadUtils';
import { trackAction } from '../../utils/trackActions';
import { CDN_CLRSAVE_URL } from '../../constants';
import styles from '../../styles/requestCallback.scss';
import cx from 'classnames';

interface Props {
  isVariant?: boolean;
  isHomePage?: boolean;
  userInfo?: any;
  alreadyInvested?: boolean;
}

interface State {
  email: string;
  phone: string;
  phoneError: boolean;
  emailError: boolean;
  callbackRequested: boolean;
  btnDisabled: boolean;
}

class RequestCallback extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      email: '',
      phone: '',
      phoneError: false,
      emailError: false,
      callbackRequested: false,
      btnDisabled: false,
    };
  }

  private handleChange = (e: any) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      ...prevState,
      [name]: value,
      phoneError: false,
      emailError: false,
    }));
  };

  public componentDidMount = () => {
    if (this.props.userInfo) {
      let { email, phoneNumber: phone } = this.props.userInfo;
      email = email || '';
      phone = phone || '';
      this.setState({ email, phone });
    }
  };

  private trackAction = () => {
    const { isHomePage } = this.props;
    if (isHomePage) {
      trackAction('request-callback', 'invest-sales', 'invest-home-page');
    } else {
      trackAction('request-callback', 'invest-sales');
    }
  };

  private callback = () => {
    const { email, phone } = this.state;
    if (!email) {
      this.setState({
        emailError: true,
      });
    } else if (!phone) {
      this.setState({
        phoneError: true,
      });
    } else {
      this.trackAction();
      this.setState({ callbackRequested: true });
      createActivity({
        ActivityEvent: 223,
        EmailAddress: email,
        Phone: phone,
        ActivityNote: 'Request Callback',
      });
    }
  };

  private handleRequestCallback = () => {
    const { email, phone } = this.state;
    const leadFundUrl = window.location.href.split('/');
    if (/^\d{10}$/.test(phone) && email) {
      this.setState({
        btnDisabled: true,
      });
      this.trackAction();
      createLeadGeneric(email, {
        leadPhoneNo: phone,
      }).then(() => {
        createActivity({
          ActivityEvent: 223,
          ActivityNote: `plan/fund - ${leadFundUrl[leadFundUrl.length - 1]}`,
          EmailAddress: email,
        }).then(() => {
          this.setState({
            callbackRequested: true,
          });
        });
      });
    } else {
      if (!email) {
        this.setState({
          emailError: true,
        });
      }
      if (!/^\d{10}$/.test(phone)) {
        this.setState({
          phoneError: true,
        });
      }
    }
  };

  public getAMCContent = () => {
    return (
      <div className="row pt30">
        <div className="columns large-12 text-center pb20 text--xxlg">
          14 Fundhouses. 360+ Mutual Funds
        </div>
        <div className="columns large-12">
          <img
            data-src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1571743058_amcslogo.jpg`}
            alt=""
            width="100%"
          />
        </div>
        <div className="columns large-12 text-center pt30">
          <Link route="/save/search">
            <a className={cx('s-btn s-btn--blue btn-shine')}>
              See all mutual funds
            </a>
          </Link>
        </div>
      </div>
    );
  };

  private renderCallbackForm = () => {
    const { email, phone, phoneError, emailError, btnDisabled } = this.state;
    const { isHomePage, userInfo } = this.props;
    return (
      <Fragment>
        <Fragment>
          <div
            className={cx('columns', {
              'large-4 large-offset-2': isHomePage,
              'large-12': !isHomePage,
            })}
          >
            <Field
              name="email"
              id="callback-email"
              placeholder="Email*"
              type="text"
              isInvalid={emailError}
              validationMessage="Please enter valid email id"
              required={false}
              className={cx('large-12 small-12 columns', styles['input-field'])}
              onChange={this.handleChange}
              value={!userInfo ? email : userInfo.email}
            />
          </div>

          <div
            className={cx('columns', {
              'large-4': isHomePage,
              'large-12': !isHomePage,
            })}
          >
            <Field
              name="phone"
              id="callback-phone"
              type="text"
              placeholder="Phone*"
              isInvalid={phoneError}
              validationMessage="Please enter valid phone number"
              required={false}
              className={cx('large-12 small-12 columns', styles['input-field'])}
              onChange={this.handleChange}
              value={phone}
            />
          </div>
        </Fragment>
        <Fragment>
          <div className="columns large-12 text-center">
            <Button
              label={
                userInfo && userInfo.email && userInfo.phoneNumber
                  ? 'Get a free callback'
                  : 'Request Callback'
              }
              type="orange"
              className="s-btn s-btn--orange"
              disabled={btnDisabled}
              loadingLabel={'Loading...'}
              onClick={
                userInfo && userInfo.email && userInfo.phoneNumber
                  ? this.callback
                  : this.handleRequestCallback
              }
            />
          </div>
        </Fragment>
      </Fragment>
    );
  };

  public render() {
    const { callbackRequested } = this.state;
    const { isHomePage, userInfo, isVariant } = this.props;
    const alreadyInvested = (userInfo && userInfo.alreadyInvested) || false;

    return (
      <Fragment>
        <div
          className={cx({
            'pt20 pb30': isHomePage,
          })}
        >
          <div className={cx({ 'desktop-only': isVariant })}>
            {isHomePage ? this.getAMCContent() : null}
            <div
              data-name="request-callback"
              id="request-callback"
              className={cx(
                'paper request-callback-block mt40 pt30',
                styles['contact-us'],
                {
                  [styles['custom-spacing-border']]: isHomePage,
                }
              )}
            >
              <div className="row">
                <div className="columns medium-8 medium-offset-2 large-12 large-offset-0">
                  <BlockHeader
                    className={cx({
                      'text-center text--xxlg': isHomePage,
                    })}
                    text={`Need help? ${
                      isHomePage ? ' Talk to our experts' : ''
                    }`}
                  />
                  {!callbackRequested ? (
                    <div className="row">
                      <div
                        className={cx('columns', {
                          'large-12': !isHomePage,
                          'large-8 large-offset-2 pl0 pr0': isHomePage,
                        })}
                      >
                        {isHomePage ? (
                          alreadyInvested ? (
                            <p className="text-center pb30">
                              If you have any queries related to your
                              investment(s), please call us on{' '}
                              <b>080-67458744</b> between Monday to Saturday,
                              10AM - 7 PM and one of our investment experts will
                              help you out.
                            </p>
                          ) : (
                            <p className="text-center pb30">
                              {userInfo &&
                              userInfo.email &&
                              userInfo.phoneNumber
                                ? 'If you have any queries click on the button below, one of our experts will give you a call to get you started on your investment journey '
                                : 'Just enter your details and one of our experts will give you a call to get you started on your investment journey '}
                              OR call us on <b>080-67458728</b> between Monday
                              to Saturday, 10AM - 7PM.
                            </p>
                          )
                        ) : (
                          alreadyInvested && (
                            <Fragment>{this.renderCallbackForm()}</Fragment>
                          )
                          // <img
                          //   className="mb20"
                          //   src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/requestcall.png`}
                          // />
                        )}
                      </div>
                      {!alreadyInvested ? (
                        <Fragment>
                          {isHomePage ? null : (
                            <div className="center">
                              <img
                                className={cx(styles['callback-img'], 'mb20')}
                                src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/requestcall.png`}
                              />
                            </div>
                          )}
                          {this.renderCallbackForm()}
                        </Fragment>
                      ) : null}
                    </div>
                  ) : (
                    <span
                      className={cx(
                        'font--faded font--bold block text-center',
                        styles.feedback
                      )}
                    >
                      Done! You'll hear from us soon.
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default RequestCallback;



// WEBPACK FOOTER //
// ./components/singleFund/requestCallback.tsx